<template>
    <router-link
        :to="{ name: 'base.installation.dashboard', params: { id: installationData.site_id } }"
        class="vrm-search-item-link"
    >
        <div
            class="vrm-search-item"
            :class="{ 'vrm-search-item--focused': isFocused }"
            data-cy="enhanced-search-item"
        >
            <div class="vrm-search-item__image">
                <VrmInstallationAvatar :installation="installationData" class="small" />
            </div>
            <div class="vrm-search-item__description">
                <p class="vrm-search-item__description-title">{{ installationData.site_name }}</p>
                <p v-if="installationData.highlight" class="vrm-search-item__description-hits">
                    <span>{{ highlightType }}</span>
                    |
                    <span v-html="highlightData.bestHighlight"></span>
                </p>
            </div>
        </div>
    </router-link>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmInstallationAvatar from '../VrmInstallationAvatar.vue';

@Component({
    props: {
        installationData: {
            type: Object,
        },
        isFocused: {
            type: Boolean,
            default: false,
        },
    },
    components: { VrmInstallationAvatar },
})
@AngularDirective('vrm-enhanced-search-item')
@AngularLocaleBundle('nav')
export default class VrmEnhancedSearchItem extends Vue {
    get highlightData() {
        const highlight = this.installationData.highlight;
        let maxEmLength = 0;
        let bestHighlight = '';
        let bestHighlightKey = '';

        Object.entries(highlight).forEach(([key, values]) => {
            values.forEach(value => {
                const emLength = (value.match(/<em>(.*?)<\/em>/g) || []).reduce(
                    (acc, match) => acc + match.length,
                    0,
                );

                if (emLength > maxEmLength) {
                    maxEmLength = emLength;
                    bestHighlight = value;
                    bestHighlightKey = key;
                }
            });
        });

        return { bestHighlight, bestHighlightKey };
    }

    get highlightType() {
        if (!this.installationData || !this.installationData.highlight) {
            return null;
        }
        const highlightKey = this.highlightData.bestHighlightKey;
        switch (highlightKey) {
            case 'site_name':
                return this.$t('nav.search_highlights.installation_name', {
                    i18nFallback: 'Installation name',
                });
            case 'site_emails.value':
                return this.$t('nav.search_highlights.email', { i18nFallback: 'User email' });
            case 'site_usernames.value':
                return this.$t('nav.search_highlights.user_name', { i18nFallback: 'User name' });
            case 'site_serials.value':
                return this.$t('nav.search_highlights.serial', {
                    i18nFallback: 'Device serial number',
                });
            case 'site_emails.domain':
                return this.$t('nav.search_highlights.domain', { i18nFallback: 'User email' });
            case 'site_identifier':
                return this.$t('nav.search_highlights.identifier', { i18nFallback: 'Identifier' });
            case 'site_id':
                return this.$t('nav.search_highlights.installation_id', {
                    i18nFallback: 'Installation ID',
                });
            default:
                return null;
        }
    }

    @Watch('isFocused', { immediate: true })
    changeFocusedElement(newValue) {
        if (newValue) {
            this.$nextTick(() => {
                // Scroll the element into view when focused
                this.$el.scrollIntoView({ block: 'nearest' });
            });
        }
    }

    navigateToItem() {
        // Navigate to the route
        this.$router.push({
            name: 'base.installation.dashboard',
            params: { id: this.installationData.site_id },
        });
    }
}
</script>
